import axiosInstance from 'utils/axios';

import {
  LoginResponseModel,
  FullIdentityLoginResponseModel,
  SettingsItemModel,
  LoginTaskResponseModel,
  UserLoginViewModel,
  CurrentUserResponseModel,
  RefreshTokenResponseModel,
} from 'api/utility/utility.model';
import { apiEndpoints } from 'apiEndpoints';

const postLogin = async (userLogin: UserLoginViewModel): Promise<LoginResponseModel> => {
  const { data } = await axiosInstance.post(apiEndpoints.utils.login, userLogin);
  return data;
};

const postFullIdentityLogin = async (
  userLogin: UserLoginViewModel
): Promise<FullIdentityLoginResponseModel> => {
  const { data } = await axiosInstance.post(apiEndpoints.utils.fullIdentityLogin, userLogin);
  return data;
};

const getFullIdentityLoginTask = async (taskId: string): Promise<LoginTaskResponseModel> => {
  const { data } = await axiosInstance.get(
    apiEndpoints.utils.fullIdentityStatus.replace('{taskId}', taskId)
  );
  return data;
};

const getCurrentUser = async (): Promise<CurrentUserResponseModel> => {
  const { data } = await axiosInstance.get(apiEndpoints.utils.me, {
    timeout: 2000,
  });
  return data;
};

const getRefreshToken = async (): Promise<RefreshTokenResponseModel> => {
  const { data } = await axiosInstance.get(apiEndpoints.utils.refreshToken);
  return data;
};

const getSettings = async (): Promise<SettingsItemModel[]> => {
  const response = await axiosInstance.get(apiEndpoints.utils.settings);
  return response.data;
};

const utility = {
  postLogin,
  postFullIdentityLogin,
  getFullIdentityLoginTask,
  getCurrentUser,
  getRefreshToken,
  getSettings,
};

export default utility;
